export const CONFIG_STORAGE_KEY = 'CONFIG_STORAGE_KEY';
